/**
 * Academic Deliverables 1031 — BDU "Hands-On Learning with Expert Faculty"
 * Tinted background image, heading on the left, numbered icon rows on the right.
 */

export const ACADEMIC_DELIVERABLES_1031_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Learning rows",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_icon: "",
    meta_icon_alt: "",
    meta_title: "INDUSTRY-DRIVEN CURRICULUM",
    meta_description:
      "Designed by experts to align with real-world business needs.",
    meta_title_color: "#F4F217",
    meta_description_color: "#FFFFFF",
    meta_priority: 1,
    meta_status: true,
  },

  ACADEMIC_DELIVERABLES_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Heading",
      value: "Hands-On Learning with Expert Faculty",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "Hands-On Learning with Expert Faculty",
    },
    {
      fieldName: "title_text_color",
      label: "Heading colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "desktop_bg_image",
      label: "Background image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      defaultValue: "",
    },
    {
      fieldName: "mobile_bg_image",
      label: "Background image (mobile fallback)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      defaultValue: "",
    },
    {
      fieldName: "alt_image",
      label: "Background image alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      fieldName: "section_background_color",
      label: "Tint over the background image (rendered at 85% opacity)",
      value: "#13344FD4",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#13344FD4",
    },
    {
      fieldName: "sub_title_text_color",
      label: "Rule between rows",
      value: "#A4A4A4",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#A4A4A4",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Icon",
      fieldName: "meta_icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload icon (34x32)",
      defaultValue: "",
    },
    {
      header: "Icon alt",
      fieldName: "meta_icon_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Title",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Description",
      fieldName: "meta_description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      defaultValue: "",
      rows: 3,
    },
    {
      header: "Title colour",
      fieldName: "meta_title_color",
      value: "#F4F217",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#F4F217",
    },
    {
      header: "Description colour",
      fieldName: "meta_description_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
